import { pxToRem } from 'utils/styled'
import styled from '@emotion/styled'
import { Caption, Text } from 'components/Typography'

export const SInfoSideModal = styled.div`
  display: flex;
  flex-direction: column;
`

export const SInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${pxToRem(24)}rem;
`

export const SInfoTextColumn = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-wrap: nowrap;
  flex-direction: column;
  margin-left: ${pxToRem(12)}rem;
`

export const STitle = styled(Text)`
  color: black;
  font-weight: bold;
  margin-bottom: ${pxToRem(40)}rem;
`

export const SInfoTitle = styled(STitle)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
`

export const SSubtitle = styled(Caption)`
  color: var(--c-gray500);
  margin-bottom: ${pxToRem(24)}rem;
`

export const SText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
